import React from 'react'

const PrivacySettings = () => {
  return (
    <div>PrivacySettings</div>
  )
}

export default PrivacySettings